import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThunder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.33073 14.6673L5.9974 10.0007H2.66406L8.66406 1.33398H9.9974L9.33073 6.66732H13.3307L6.66406 14.6673H5.33073Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgThunder);
export default ForwardRef;
